const requestMagazine = async(payload) => {
    try {
      return await axios.post(`catalog/magazine/request`, {...payload})
    } catch (e) {
      throw e
    }
  }
  

export {
    requestMagazine,
}
  